import {ActionReducerMap} from '@ngrx/store';
import {FenceResultEntityState, fenceResultReducer} from '@app/store/faxe/fence-result/fence-result.reducer';
import {FenceEntityState, fenceReducer} from '@app/store/faxe/fences/fence.reducer';
import {ResultCodeEntityState, resultCodeReducer} from '@app/store/faxe/results-code/result-code.reducer';
import {RaceClassEntityState, raceClassReducer} from '@app/store/faxe/race-class/race-class.reducer';
import {ClubLogoEntityState, clubLogoReducer} from '@app/store/faxe/club-logo/club-logo.reducer';
import {RiderEventEntityState, riderEventReducer} from '@app/store/faxe/rider-event/rider-event.reducer';
import {RiderEntityState, riderReducer} from '@app/store/faxe/rider/rider.reducer';
import { RaceEntityState, raceReducer } from '@app/store/faxe/race/race.reducer';
import {
  MultiContractDataEntityState,
  multiContractDataReducer
} from '@app/store/faxe/multi-contract/multi-contract-reducer';

export interface FaxeStore {
  readonly rider: RiderEntityState;
  readonly fenceResult: FenceResultEntityState;
  readonly fence: FenceEntityState;
  readonly resultCode: ResultCodeEntityState;
  readonly riderEvent: RiderEventEntityState;
  readonly raceClass: RaceClassEntityState;
  readonly clubLogo: ClubLogoEntityState;
  readonly race: RaceEntityState;
  readonly multiContractData: MultiContractDataEntityState;
}

export const faxeReducers: ActionReducerMap<FaxeStore> = {
  rider: riderReducer,
  fenceResult: fenceResultReducer,
  fence: fenceReducer,
  resultCode: resultCodeReducer,
  riderEvent: riderEventReducer,
  raceClass: raceClassReducer,
  clubLogo: clubLogoReducer,
  race: raceReducer,
  multiContractData: multiContractDataReducer
};
